import { ArrowRight, Wallet, Send, CheckCircle } from 'lucide-react'

const steps = [
  {
    icon: Wallet,
    title: 'Create Wallet',
    description: 'tchcash creates a wallet automatically and saves it to your local machine',
    step: '1',
  },
  {
    icon: Send,
    title: 'Fund Wallet',
    description: 'Transfer TCH tokens to your wallet address (recommended: 10 TCH)',
    step: '2',
  },
  {
    icon: CheckCircle,
    title: 'Check Balance',
    description: 'Verify you have sufficient funds before making paid API calls',
    step: '3',
  },
  {
    icon: Send,
    title: 'Call APIs',
    description: 'Make paid API calls. tchcash automatically pays using your wallet',
    step: '4',
  },
]

export function HowItWorks() {
  return (
    <section className="py-24 md:py-32">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-sentient mb-8">
            How <span className="text-primary italic">It Works</span>
          </h2>
          <p className="text-lg text-foreground/60 leading-relaxed">
            Simple 4-step process to start using paid APIs with your AI agent
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                {/* Connection line */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-8 left-full w-full h-0.5 bg-gradient-to-r from-primary/50 to-transparent" />
                )}

                <div className="relative z-10 flex flex-col items-center text-center">
                  {/* Step number */}
                  <div className="w-16 h-16 rounded-full bg-primary/10 border-2 border-primary flex items-center justify-center mb-4 relative">
                    <span className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-primary text-background text-xs font-bold flex items-center justify-center">
                      {step.step}
                    </span>
                    <step.icon className="w-8 h-8 text-primary" />
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
                  <p className="text-sm text-foreground/60 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Payment Flow Diagram */}
          <div className="mt-20 border border-foreground/10 rounded-lg p-8 bg-foreground/2">
            <h3 className="text-xl font-semibold mb-6 text-center">Payment Flow</h3>
            <div className="flex flex-col items-center gap-4 font-mono text-sm">
              <div className="flex items-center gap-2 text-primary">
                <span className="px-3 py-1 bg-primary/10 rounded">Agent</span>
                <ArrowRight className="w-4 h-4" />
                <span className="px-3 py-1 bg-foreground/10 rounded">tchcash</span>
                <ArrowRight className="w-4 h-4" />
                <span className="px-3 py-1 bg-foreground/10 rounded">tchmpp</span>
                <ArrowRight className="w-4 h-4" />
                <span className="px-3 py-1 bg-foreground/10 rounded">ThaiChain</span>
              </div>
              <div className="text-foreground/60 text-xs mt-2">
                402 challenge → sign → broadcast → verify → return data
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
